import { useContext, useEffect, useState } from "react"
import useService from "../../hooks/useService"
import Loader from "../custom/Loader"
import { AuthContext, initialUserData } from "../../contexts/AuthContext"
import Cookies from "universal-cookie"
import { verifyAuth } from "../../services/Auth"

const LoadingWrapper = (props: any) => {
    const { execute, loading } = useService()
    const { setAuthState, setUser } = useContext(AuthContext)
    const cookies = new Cookies()
    const sessionId = cookies.get('sessionId')
    const [authLoading, setAuthLoading] = useState(false)

    const verifySession = async() => {
        if (Boolean(sessionId)) {
            setAuthLoading(true)
            execute(() => verifyAuth(null))
            setAuthLoading(false)
        }
        else {
            setAuthState({ sessionId: "" });
            setUser(initialUserData)
            cookies.remove("sessionId");
        }
    }

    useEffect(() => {
        verifySession()
    }, [sessionId])

    return <>
        {!authLoading && props.children}
        {loading ? <Loader /> : <></>}
    </>
}

export default LoadingWrapper